import {v4 as uuidv4} from 'uuid';

import BenchlingConfig from 'BenchlingConfig';

import {makeFormattedTextSearchResultData} from '../formatted-text/FormattedTextSearchResults';
import {TextMatcher, MediocreSearchResult} from './SearchResults';

export function getSearchResultsForInternalLink(
  matcher: TextMatcher,
  internalLinks: Array<{
    position: number;
    data: {id: string; name: string; url: string; cachedDisplayInfo?: {displayLabel: string}};
  }>,
  cid: string
): Array<{result: MediocreSearchResult; position: number}> {
  const searchResultsByPosition: Array<{result: MediocreSearchResult; position: number}> = [];
  for (const internalLink of internalLinks) {
    let effectiveName;
    if (BenchlingConfig.ENABLE_FROZEN_CHIPS) {
      effectiveName = internalLink.data.cachedDisplayInfo?.displayLabel || internalLink.data.name;
    } else {
      effectiveName = internalLink.data.name;
    }
    for (const match of matcher.findAllMatches(effectiveName)) {
      const [matchedText] = match;
      const start = match.index;
      const end = start + matchedText.length;
      searchResultsByPosition.push({
        result: {
          index: [cid, internalLink.data.id],
          data: makeFormattedTextSearchResultData(start, end),
          selection: {
            selection: {
              cid,
              start,
              end,
            },
          },
          uuid: uuidv4(),
        },
        position: internalLink.position,
      });
    }
  }
  return searchResultsByPosition;
}
